"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MemoryRouter", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.MemoryRouter;
  }
});
Object.defineProperty(exports, "Prompt", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.Prompt;
  }
});
Object.defineProperty(exports, "Redirect", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.Redirect;
  }
});
Object.defineProperty(exports, "Route", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.Route;
  }
});
Object.defineProperty(exports, "Router", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.Router;
  }
});
Object.defineProperty(exports, "StaticRouter", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.StaticRouter;
  }
});
Object.defineProperty(exports, "Switch", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.Switch;
  }
});
Object.defineProperty(exports, "generatePath", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.generatePath;
  }
});
Object.defineProperty(exports, "matchPath", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.matchPath;
  }
});
Object.defineProperty(exports, "useHistory", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.useHistory;
  }
});
Object.defineProperty(exports, "useParams", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.useParams;
  }
});
Object.defineProperty(exports, "useRouteMatch", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.useRouteMatch;
  }
});
Object.defineProperty(exports, "withRouter", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.withRouter;
  }
});
Object.defineProperty(exports, "BrowserRouter", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.BrowserRouter;
  }
});
Object.defineProperty(exports, "HashRouter", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.HashRouter;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.default;
  }
});
exports.useLocation = exports.NavLink = exports.Link = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = _interopRequireWildcard(require("react-router-dom"));

var _reactRouter = require("react-router");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Boilerplate = window.cccisd && window.cccisd.boilerplate; // Reexporting everything from 'react-router-dom' except for the Link and NavLink.
// Link/NavLink should be rendered as a regular <a> if it's outside of react-router context

var Link = function Link(props) {
  var router = (0, _react.useContext)(_reactRouter.__RouterContext);

  if (router) {
    return _react.default.createElement(_reactRouterDom.Link, props);
  } // eslint-disable-next-line no-unused-vars


  var to = props.to,
      children = props.children,
      passingProps = _objectWithoutProperties(props, ["to", "children"]);

  return _react.default.createElement("a", _extends({}, passingProps, {
    href: Boilerplate.url(props.to)
  }), children);
};

exports.Link = Link;

var NavLink = function NavLink(props) {
  var router = (0, _react.useContext)(_reactRouter.__RouterContext);

  if (router) {
    return _react.default.createElement(_reactRouterDom.NavLink, props);
  } // eslint-disable-next-line no-unused-vars


  var to = props.to,
      children = props.children,
      passingProps = _objectWithoutProperties(props, ["to", "children"]);

  return _react.default.createElement("a", _extends({}, passingProps, {
    href: Boilerplate.url(props.to)
  }), children);
};

exports.NavLink = NavLink;

var useLocation = function useLocation(props) {
  var router = (0, _react.useContext)(_reactRouter.__RouterContext);

  if (router) {
    return (0, _reactRouterDom.useLocation)();
  }

  return window.location;
};

exports.useLocation = useLocation;